import { useEffect } from 'react';

const useHtmlLang = (lang) => {
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
};

export default useHtmlLang;
